/**
 * Prepends hash number with `hash` keyword and pads the rest with zeros towards the max safe integer.
 * Also prepends hash number with leading 1 if the calculated number is negative.
 *
 * @param hashNumber -
 * @returns - string of the following format: hash0000000000000000
 */
const padHashNumber = (hashNumber: number): string =>
  `hash${hashNumber >= 0 ? 0 : 1}${String(Math.abs(hashNumber)).padStart(15, '0')}`;

/**
 * Simple string hashing algorithm.
 * Do not use for security purposes.
 * No statistical data collision analysis done.
 *
 * @param input - input string to be hashed
 * @returns hashed number
 */

export const simpleHash = (input: string): string =>
  padHashNumber(
    input
      .split('')
      // eslint-disable-next-line no-bitwise
      .reduce((hash, char) => (Math.imul(31, hash) + char.charCodeAt(0)) | 0, 0),
  );
